import { render, staticRenderFns } from "./ThePopups.vue?vue&type=template&id=0ba0ca36"
import script from "./ThePopups.vue?vue&type=script&lang=js"
export * from "./ThePopups.vue?vue&type=script&lang=js"
import style0 from "./ThePopups.vue?vue&type=style&index=0&id=0ba0ca36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports